import React, { createContext, useContext } from 'react';

interface SubscriptionContextType {
  subscription: any | null;
  isLoading: boolean;
}

const SubscriptionContext = createContext<SubscriptionContextType>({
  subscription: null,
  isLoading: false,
});

export const useSubscription = () => useContext(SubscriptionContext);

export function SubscriptionProvider({ children }: { children: React.ReactNode }) {
  return (
    <SubscriptionContext.Provider value={{ subscription: null, isLoading: false }}>
      {children}
    </SubscriptionContext.Provider>
  );
}
